export type BulletEvent = {
  x: number;
  y: number;
  vx: number;
  vy: number;
  r?: number;
};

export function ringBurst(
  cx: number,
  cy: number,
  count: number,
  speed: number,
  phase = 0,
): BulletEvent[] {
  const out: BulletEvent[] = [];
  for (let i = 0; i < count; i++) {
    const a = phase + (i / count) * Math.PI * 2;
    out.push({
      x: cx,
      y: cy,
      vx: Math.cos(a) * speed,
      vy: Math.sin(a) * speed,
    });
  }
  return out;
}

export function aimedShot(
  fromX: number,
  fromY: number,
  toX: number,
  toY: number,
  speed: number,
): BulletEvent {
  const dx = toX - fromX;
  const dy = toY - fromY;
  const len = Math.hypot(dx, dy) || 1;
  return {
    x: fromX,
    y: fromY,
    vx: (dx / len) * speed,
    vy: (dy / len) * speed,
  };
}

export function sweepBar(
  y: number,
  width: number,
  count: number,
  speed: number,
  dir: 1 | -1,
): BulletEvent[] {
  const out: BulletEvent[] = [];
  for (let i = 0; i < count; i++) {
    const t = count === 1 ? 0.5 : i / (count - 1);
    out.push({
      x: t * width,
      y,
      vx: dir * speed * 0.15,
      vy: speed,
    });
  }
  return out;
}

export function wallWithGap(
  y: number,
  width: number,
  gapCenter: number,
  gapWidth: number,
  spacing: number,
  speed: number,
): BulletEvent[] {
  const out: BulletEvent[] = [];
  for (let x = 0; x <= width; x += spacing) {
    if (Math.abs(x - gapCenter) < gapWidth / 2) continue;
    out.push({ x, y, vx: 0, vy: speed });
  }
  return out;
}
